// removed by extract-text-webpack-plugin
module.exports = {"app":"_2_4fdsYhQXSAY8WsmZ_FAl"};


//////////////////
// WEBPACK FOOTER
// ./src/sections/App/App.css
// module id = 186
// module chunks = 0